"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var icons_1 = require("../../icons");
var style_1 = require("../../style");
var variables_1 = require("../../style/variables");
var Flex_1 = __importDefault(require("../layout/Flex"));
var QuickJumper_1 = __importDefault(require("./QuickJumper"));
var SizeChanger_1 = __importDefault(require("./SizeChanger"));
var styles = {
    container: react_1.css({
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        borderRadius: style_1.pxToRem(5),
        width: 'fit-content',
        overflow: 'hidden',
    }),
    default: react_1.css({
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.5,
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: style_1.pxToRem(35),
        minHeight: style_1.pxToRem(35),
        color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
        background: "var(" + variables_1.RootColor.White + ")",
        borderLeft: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        '&:first-child': {
            borderLeft: 'none',
        },
        cursor: 'pointer',
        '&:hover': {
            background: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
    }),
    disabled: react_1.css({
        cursor: 'not-allowed',
        color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        background: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
    }),
    active: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
        background: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
    }),
    controllers: react_1.css({
        fontSize: 14,
        lineHeight: '21px',
        color: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
    }),
};
var getPageGroup = function (activePage, startingPage, groupSize, onChange) {
    var pageGroup = [];
    var _loop_1 = function (idx) {
        pageGroup.push(react_1.jsx("li", { css: [styles.default, idx === activePage ? styles.active : undefined], onClick: function () { return onChange(idx); }, key: idx }, idx));
    };
    for (var idx = startingPage; idx < startingPage + groupSize; idx++) {
        _loop_1(idx);
    }
    return pageGroup;
};
var Pagination = function (_a) {
    var page = _a.page, onChange = _a.onChange, totalCount = _a.totalCount, pageSize = _a.pageSize, pageSizeOptions = _a.pageSizeOptions, _b = _a.groupSize, groupSize = _b === void 0 ? 5 : _b, onPageSizeChange = _a.onPageSizeChange, _c = _a.size, size = _c === void 0 ? 'sm' : _c;
    var _d = react_2.useState(false), mouseOverForward = _d[0], setMouseOverForward = _d[1];
    var _e = react_2.useState(false), mouseOverBackward = _e[0], setMouseOverBackward = _e[1];
    var pageCount = Math.ceil(totalCount / pageSize);
    /*   // checking relative validity of inputs (i.e totalCount, page, pageSize)
    if (page > pageCount || (totalCount > 0 && page === 0) || (totalCount === 0 && page !== 0)) {
      return <div>Incorrect input</div>;
    } */
    // handling previous button call
    var renderPreviousController = function () {
        var containerStyle = [
            styles.default,
            size === 'lg' && react_1.css({ gap: 8, paddingLeft: 10, paddingRight: 10 }),
            page > 1 ? styles.controllers : styles.disabled,
        ];
        return (react_1.jsx("li", { css: containerStyle, onClick: function () { return (page > 1 ? onChange(page - 1) : undefined); }, key: 'arrowLeft' },
            react_1.jsx(icons_1.ArrowNarrowLeft, { size: style_1.pxToRem(16) }),
            size === 'lg' && react_1.jsx("span", null, "Previous")));
    };
    // handling next button call
    var renderNextController = function () {
        var containerStyle = [
            styles.default,
            size === 'lg' && react_1.css({ gap: 8, paddingLeft: 10, paddingRight: 10 }),
            page < pageCount ? styles.controllers : styles.disabled,
        ];
        return (react_1.jsx("li", { css: containerStyle, onClick: function () { return (page < pageCount ? onChange(page + 1) : undefined); }, key: 'arrowRight' },
            size === 'lg' && react_1.jsx("span", null, "Next"),
            react_1.jsx(icons_1.ArrowNarrowRight, { size: style_1.pxToRem(16) })));
    };
    // handling display for rest of all page buttons
    var renderDisplay = function () {
        var showForwardDOTS = true;
        var showBackwardDOTS = true;
        var firstPageGroup, middlePageGroup, lastPageGroup;
        var handleMouseOver = function (forwardDirection) {
            if (mouseOverForward && forwardDirection) {
                return react_1.jsx(icons_1.ChevronRightDouble, { size: style_1.pxToRem(16), color: "var(" + variables_1.RootColor.Black + ")" });
            }
            else if (mouseOverBackward && !forwardDirection) {
                return react_1.jsx(icons_1.ChevronLeftDouble, { size: style_1.pxToRem(16), color: "var(" + variables_1.RootColor.Black + ")" });
            }
            else {
                return react_1.jsx(icons_1.DotsHorizontal, { size: style_1.pxToRem(16) });
            }
        };
        var handleDOTSClick = function (forwardDirection) {
            if (forwardDirection) {
                return onChange(page + groupSize <= pageCount ? page + groupSize : pageCount);
            }
            else {
                return onChange(page - groupSize > 0 ? page - groupSize : 1);
            }
        };
        var DOTS = function (forwardDirection) { return (react_1.jsx("li", { css: styles.default, onClick: function () { return handleDOTSClick(forwardDirection); }, onMouseEnter: function () {
                return forwardDirection ? setMouseOverForward(true) : setMouseOverBackward(true);
            }, onMouseLeave: function () {
                return forwardDirection ? setMouseOverForward(false) : setMouseOverBackward(false);
            }, key: forwardDirection ? 'forward' : 'backward' }, handleMouseOver(forwardDirection))); };
        /*
        if pageCount is less than groupSize, it will create non-existing pages
        hence, handling the condition by making them same
        */
        if (pageCount <= groupSize) {
            groupSize = pageCount;
        }
        var refPage = Math.floor(groupSize / 2);
        var block = 3 + refPage;
        if (pageCount < block + 2) {
            return getPageGroup(page, 1, pageCount, onChange);
        }
        firstPageGroup = getPageGroup(page, 1, 1, onChange);
        lastPageGroup = getPageGroup(page, pageCount, 1, onChange);
        if (page <= block) {
            firstPageGroup = getPageGroup(page, 1, block, onChange);
            showBackwardDOTS = false;
        }
        else if (page > pageCount - block) {
            showForwardDOTS = false;
            lastPageGroup = getPageGroup(page, pageCount - block + 1, block, onChange);
        }
        else {
            middlePageGroup = getPageGroup(page, page - refPage, groupSize, onChange);
        }
        return [
            firstPageGroup,
            showBackwardDOTS ? DOTS(false) : undefined,
            middlePageGroup,
            showForwardDOTS ? DOTS(true) : undefined,
            lastPageGroup,
        ];
    };
    var pagination = (react_1.jsx(Flex_1.default, { css: styles.container, justifyContent: "flex-start", alignItems: "center", wrap: "wrap" },
        renderPreviousController(),
        renderDisplay(),
        renderNextController()));
    if (size === 'sm') {
        return pagination;
    }
    return (react_1.jsx(Flex_1.default, { alignItems: "center", justifyContent: "space-between", css: react_1.css({
            padding: '12px 24px',
        }) },
        react_1.jsx(QuickJumper_1.default, { totalPages: pageCount, currentPage: page, onChange: onChange }),
        pagination,
        react_1.jsx(SizeChanger_1.default, { value: pageSize, options: pageSizeOptions, onChange: function (newPageSize) {
                if (newPageSize * page > totalCount) {
                    onChange(Math.floor(totalCount / newPageSize));
                }
                onPageSizeChange === null || onPageSizeChange === void 0 ? void 0 : onPageSizeChange(newPageSize);
            } })));
};
exports.default = Object.assign(Pagination, {
    SizeChanger: SizeChanger_1.default,
    QuickJumper: QuickJumper_1.default,
});
